import { Link } from "react-router-dom";
import styles from "./home-about.module.css";
import { useCallback, useEffect, useState } from "react";
import { getHomeAbout } from "../../services/about/about.service";
import CountUp from "react-countup";
import { toFarsiNumber, numberWithSeparator } from "../../utils/helper";
import HomeAboutSlider from "./home-about-slider";

export default function HomeAbout() {
  const [about, setAbout] = useState(null);
  useEffect(() => {
    getHomeAbout().then(({ data }) => {
      setAbout(data && data.data);
    });
  }, []);
  const handleCounter = useCallback((value, decimalSeparator = null) => {
    return toFarsiNumber(numberWithSeparator(value, decimalSeparator));
  });
  return (
    <div className={styles.aboutWrapper}>
      <div className="container">
        <div className={styles.aboutContainer}>
          <div className={styles.aboutContent}>
            <div className={styles.aboutContentTitle}>
              درباره شرکت خدمات انفورماتیک
            </div>
            <div className={styles.aboutContentSubTitle}>
              اولین و بزرگ ترین شرکت ارائه دهنده زیر ساخت ها و راه کار های بانکی
              در خاورمیانه
            </div>
            <div
              className={styles.aboutContentBody}
              dangerouslySetInnerHTML={{
                __html:
                  Array.isArray(about) && about.length > 0
                    ? about[0].context
                    : null,
              }}
            />
            <ul className={styles.linksContainer}>
              <li>
                <Link
                  to={"/about?t=IscIntroduction"}
                  className={styles.linkText}
                >
                  ادامه مطلب <i className="fa fa-arrow-left" />
                </Link>
              </li>
            </ul>
            <div className={styles.Statistics}>
              <div className={styles.StatisticsRow}>
                <div className={styles.StatisticsBox}>
                  <div className={styles.imageIcon}>
                    <img src={"/assets/image/about-transaction.svg"} />
                  </div>
                  <div className={styles.numberInfo}>
                    <span className={styles.extraSeparator}>رتبه</span>
                    <span>۱</span>
                  </div>
                  <div className={styles.contentAbout}>
                    در کلیه شاخص‌های شورای عالی انفورماتیک
                  </div>
                </div>
                <div className={styles.StatisticsBox}>
                  <div className={styles.imageIcon}>
                    <img src={"/assets/image/about-user.svg"} />
                  </div>
                  <div className={styles.numberInfo}>
                    <CountUp
                      scrollSpyOnce={true}
                      useEasing={false}
                      start={80}
                      end={320}
                      duration={6}
                      formattingFn={(value) => handleCounter(value)}
                      enableScrollSpy
                      className={styles.activeUserCountUp}
                    />
                    <span className={styles.extraSeparator}>+</span>
                  </div>
                  <div className={styles.contentAbout}>
                    میلیارد تراکنش بانکی و بین بانکی مدیریت شده در سال
                  </div>
                </div>
              </div>
              <div className={styles.StatisticsRow}>
                <div className={styles.StatisticsBox}>
                  <div className={styles.imageIcon}>
                    <img src={"/assets/image/about-branch.svg"} />
                  </div>
                  <div className={styles.numberInfo}>
                    <CountUp
                      scrollSpyOnce={true}
                      useEasing={false}
                      start={1000}
                      end={7200}
                      duration={6}
                      enableScrollSpy
                      formattingFn={(value) => handleCounter(value)}
                      className={styles.activeBranchCountUp}
                    />
                    <span className={styles.extraSeparator}>+</span>
                  </div>
                  <div className={styles.contentAbout}>
                    سرویس‌دهی به شعب بانکی در سراسر کشور
                  </div>
                </div>
                <div className={styles.StatisticsBox}>
                  <div className={styles.imageIcon}>
                    <img src={"/assets/image/about-stability.svg"} />
                  </div>
                  <div className={styles.numberInfo}>
                    <CountUp
                      scrollSpyOnce={true}
                      useEasing={false}
                      start={10.0}
                      end={99.9}
                      duration={6}
                      decimals={1}
                      enableScrollSpy
                      formattingFn={(value) => handleCounter(value, "/")}
                      className={styles.staticStyles}
                    />
                    <span className={styles.extraSeparator}>%</span>
                  </div>
                  <div
                    className={`${styles.decimalCounter} ${styles.contentAbout}`}
                  >
                    پایداری سامانه­ ها
                  </div>
                </div>
              </div>
            </div>
          </div>
          <HomeAboutSlider />
        </div>
      </div>
    </div>
  );
}
